import React from 'react'
type PropsViewer = {
    style?:any
    file?:string
}
export default function PDFViewer(props:PropsViewer) {
    const {file, style} = props
    return (
        <>
            <iframe src={`/pdfjs-4.0.269-dist/web/viewer.html?file=${file || '/static_media_pdf-file.d751950f.pdf'}&pagemode=thumbs`} style={{...style}} />
        </>
    )
}
